import { type TranslationTree } from '@/i18n/types';

export const messages = {
  impressions: 'Impressões',
  clicks: 'Cliques',
  ctr: 'CTR',
  hidden: '— menos de 20 pessoas',
  empty: 'Nenhuma impressão no período.',
} satisfies TranslationTree;
